import NumbersSVG from '@public/svg/map-numbers/Numbers-07092026.svg';
import { forwardRef, useEffect } from 'react';

interface MapPavilionProps extends React.SVGProps<SVGSVGElement> {}

const MapPavilionInner = (props: MapPavilionProps, ref: React.Ref<SVGSVGElement>) => {
    useEffect(() => {
        return () => {
            const svgElement = (ref as React.RefObject<SVGSVGElement>)?.current;
            if (!svgElement) return;

            const container = svgElement.closest('.js-map__plan');
            if (container) {
                container.scrollTop = container.scrollHeight;

                container.scrollTo({
                    top: container.scrollHeight,
                    behavior: 'smooth',
                });
            }
        };
    }, [ref]);

    return (
        <div className="map-section-wrapper-item" style={props.style}>
            <NumbersSVG className="map-svg__numbers" />

            <svg
                ref={ref}
                className="map__rooms js-pavilion-map__rooms"
                viewBox="0 0 1657 574"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="room-info" className="unoccupied">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M197 81H279V23H197V81Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-s1">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M282 23H744V65.1818C744 73 735 81.0823 728.25 81H282V23Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-m1">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M847 22.75H1015V80.75H862.992C854.16 80.75 847 73.6677 847 64.9318V22.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-m2">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1018 80.75H1103V22.75H1018V80.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-m3">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1106 80.75H1211V22.75H1106V80.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-s2">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1214 80.75H1268V22.75H1214V80.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-s3">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1271 80.75H1325V22.75H1271V80.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-s4">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1329 80.75H1395V22.75H1329V80.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-s5">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1398 80.75H1467V22.75H1398V80.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-s6">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1470 80.75H1540V22.75H1470V80.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-m4">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1543 80.75H1644V22.75H1543V80.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-l1">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M552 163.612C552 154.852 559.186 147.75 568.05 147.75H659V239.75H552V163.612Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-l2">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M552 333.75H659V242.75H552V333.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-l3">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M552 336.75H659V429.75H568.05C559.186 429.75 552 422.571 552 413.716V336.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-l4">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M780 286.75C780 268.565 777.278 250.036 771.989 233.234C766.7 216.434 758.948 201.168 749.175 188.309C739.403 175.451 727.8 165.249 715.032 158.291C702.662 151.549 689.432 147.977 676.053 147.761L674.757 147.75H662V286.75H780Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-l5">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M780 289.75C780 308.065 777.278 326.728 771.989 343.65C766.7 360.572 758.948 375.948 749.175 388.899C739.403 401.85 727.8 412.125 715.032 419.133C702.662 425.924 689.432 429.521 676.053 429.739L674.757 429.75H662V289.75H780Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-i1" className="position-right">
                    <path
                        d="M920.879 147.75H807.384C802.554 147.75 796.715 154.494 799.916 162.274C803.117 170.056 826.053 189.249 834.125 222.84C842.199 256.432 840.888 286.75 840.888 286.75L920.879 286.623V147.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-i2" className="position-left">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M924 147.75H1037.62C1042.45 147.75 1048.28 154.494 1045.08 162.274C1041.88 170.056 1018.95 189.249 1010.88 222.84C1002.8 256.432 1004.12 286.75 1004.12 286.75L924.121 286.623"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-i3" className="position-right">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M921 429.75H807.384C802.554 429.75 796.715 422.957 799.916 415.121C803.117 407.284 826.053 387.952 834.125 354.12C842.199 320.286 840.888 289.75 840.888 289.75L920.879 289.878"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-i4" className="position-left">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M924 429.75H1037.62C1042.45 429.75 1048.28 422.957 1045.08 415.121C1041.88 407.284 1018.95 387.952 1010.88 354.12C1002.8 320.286 1004.12 289.75 1004.12 289.75L924.121 289.878"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-i5">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1273 168.224C1251.87 156.184 1227.93 149.817 1203.55 149.751C1179.17 149.685 1155.2 155.922 1134 167.846C1112.8 179.77 1095.1 196.97 1082.65 217.748C1070.2 238.525 1063.43 262.163 1063 286.328L1203.16 288.75L1273 168.224Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-i6">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1272.95 411.75C1294.32 399.691 1312.14 382.161 1324.61 360.935C1337.09 339.709 1343.77 315.539 1343.99 290.874C1344.21 266.209 1337.95 241.924 1325.85 220.479C1313.75 199.032 1296.24 181.187 1275.09 168.75L1205 289.635L1272.95 411.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-i7">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1063.04 287.75C1062.48 312.386 1068.45 336.731 1080.33 358.321C1092.21 379.911 1109.58 397.978 1130.69 410.694C1151.8 423.41 1175.9 430.322 1200.54 430.731C1225.18 431.14 1249.49 425.031 1271 413.024L1202.86 290.901L1063.04 287.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-i8" className="position-right">
                    <path
                        d="M1376.67 148.501H1376.67L1473.57 148.702H1473.57C1493.42 148.702 1511.9 164.228 1525.44 189.634C1538.97 215.014 1547.5 250.13 1547.5 288.999C1547.5 327.868 1538.93 363.285 1525.35 388.968C1511.76 414.678 1493.24 430.5 1473.39 430.5H1374.77C1369.7 430.5 1365.74 427.175 1363.8 422.652C1361.85 418.128 1361.97 412.481 1365 407.962C1424.76 318.635 1405.66 232.233 1366.47 171.181V171.18C1363.5 166.562 1363.48 160.848 1365.51 156.297C1367.53 151.747 1371.57 148.437 1376.67 148.501Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-pz" className="unoccupied">
                    <path
                        d="M298.019 147.5H454.272L400.379 195.606L400.212 195.755V254.595H282.5V163.019C282.5 154.444 289.444 147.5 298.019 147.5Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-el" className="unoccupied">
                    <path
                        d="M475.25 147.512C483.813 147.512 490.769 154.456 490.769 163.03V413.981C490.769 422.556 483.825 429.5 475.25 429.5H298.019C289.455 429.5 282.5 422.556 282.5 413.981V258.448H404.064V197.417L459.389 147.512H475.25Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-s11">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M197 553H279V495H197V553Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-s10">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M282 494.727L573 494.726V553.326H282V494.727Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-s9">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M744 553H576V495H728.008C736.84 495 744 502.082 744 510.818V553Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-m11">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M847 510.568C847 501.832 854.111 494.75 862.882 494.75H933V552.75H847V510.568Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-m10">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M936 552.75H1024V494.75H936V552.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-m9">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1027 552.75H1114V494.75H1027V552.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-m8">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1117 553H1169V495H1117V553Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-m7">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1172 553H1287V495H1172V553Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-m6">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1290 553H1406V495H1290V553Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-m5">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1409 552.75H1496V494.75H1409V552.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-s8">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1499 552.75H1550V494.75H1499V552.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="room-s7">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1553 552.75H1620V494.75H1553V552.75Z"
                        stroke="white"
                        strokeWidth={0.5}
                    />
                </g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M193.65 331.8H191.517V194.149H8.13238V375.549H163.796V377.683H8.13238V559.082H191.517V425.7H193.65V559.082H744V561.216L626.523 561.216H993.293L813.107 561.216V559.082H1646.87V425.7H1649V561.216L993.293 561.216H626.523L6 561.216V192.015H191.517V169.607H193.65V331.8ZM1649 336.068H1646.87V14.8842H836V12.75H1649V336.068ZM762 14.8842H193.65V81.7063H191.517V12.75H762V14.8842Z"
                    fill="#D9D9D9"
                />
            </svg>
        </div>
    );
};

const MapPavilion = forwardRef<SVGSVGElement, MapPavilionProps>(MapPavilionInner);

MapPavilion.displayName = 'MapPavilion';
export default MapPavilion;
